import { createFileRoute } from "@tanstack/react-router";
import ContingentTabPanel from "@/components/dashboard/contingent-tab-panel";

export const Route = createFileRoute("/_app/dashboard/contingent/")({
	component: ContingentTabPanel,
});
